<template>
    <div class="list_item" @click="goDetailPage">
        <div class="img">
            <img-box
                :src="cellData.previewPicture"
                :errorImg="errorImg"
                :alt="$ft.formatAddr(cellData.address)"
            />
            <span class="property-type">{{ cellData.propertyType }}</span>
            <ul>
                <li>
                    {{
                        $t('md-listing-list.bed', { count: !isShowMask ? cellData.bedrooms : '***' })
                    }}
                </li>
                <li>
                    {{
                        $t('md-listing-list.bath', {
                            count: !isShowMask ? cellData.bathrooms : '***'
                        })
                    }}
                </li>
                <li>{{ !isShowMask ? cellData.sqft : '*** ' + $t('md-listing-list.sqft') }}</li>
            </ul>
            <VerifyMask v-if="isShowMask" />
        </div>
        <div class="info">
            <only-client>
                <div
                    class="sold-date"
                    v-if="isSoldListing"
                    v-text="getDate(cellData.listDate)"
                ></div>
            </only-client>
            <div class="price">
                <div class="show-price" v-if="!isShowMask" v-show="showPrice">
                    <p>
                        {{
                            $ft.formatUnitNum(
                                cellData.showPrice,
                                false,
                                0,
                                currencySymbol
                            )
                        }}
                    </p>
                    <span
                        v-if="cellData.status !== 0"
                        :class="{
                            up: cellData.status > 0,
                            down: cellData.status < 0
                        }"
                    >
                        <i
                            class="iconfont icon-arrow_04_down"
                            :class="{
                                up: cellData.status > 0,
                                down: cellData.status < 0
                            }"
                        ></i>
                        {{ changePriceNum }}</span
                    >
                </div>
                <PriceMask v-else />
            </div>
            <div class="address">
                <a :href="cellData.link" rel="noopener noreferrer">{{
                    !isShowMask ? $ft.formatAddr(cellData.address) : $t('addressNotDisclosed')
                }}</a>
            </div>
            <div class="mls-info" v-if="cellData.listingProvided">
                <p class="desc">{{ !isShowMask ? cellData.listingProvided : '' }}</p>
                <site-img
                    v-if="cellData.smallLogo"
                    :src="cellData.smallLogo"
                    class="mls-logo"
                    alt="mls logo"
                />
            </div>
        </div>
    </div>
</template>

<script>
import common from '../../../_mixins/table-item/common';
import OnlyClient from '@/components/global/only-client.vue';
export default {
    name: 'table-item',
    components: { OnlyClient },
    mixins: [common]
};
</script>

<style lang="scss">
.list-table-mb.broker{
    .list_item {
        margin-top: 15px;
        border-radius: 5px;
        border: 1px solid #dadada;
        .img {
            width: 100%;
            height: 210px;
            border-radius: 5px 5px 0 0;
            position: relative;
            &:after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-image: linear-gradient(
                    to bottom,
                    rgba(255, 255, 255, 0),
                    rgba(0, 0, 0, 0.7) 100%
                );
                z-index: 1;
            }
            .img-box {
                height: 210px;
            }
            .property-type {
                position: absolute;
                left: 15px;
                top: 15px;
                font: 12px var(--font-bold);
                color: #fff;
                padding: 4px 5px;
                line-height: 1em;
                background: #348cff;
                border-radius: 5px;
                max-width: calc(100% - 30px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                z-index: 2;
            }
            & > ul {
                position: absolute;
                left: 5px;
                bottom: 15px;
                display: flex;
                flex-direction: row;
                z-index: 3;
                li:first-child:before {
                    display: none;
                }
                li {
                    font: 12px var(--font-normal);
                    color: #fff;
                    line-height: 15px;
                    padding: 0 10px;
                    position: relative;
                    &:before {
                        content: '';
                        width: 1px;
                        height: 8px;
                        position: absolute;
                        left: 0;
                        top: 50%;
                        background: #dadada;
                        transform: translateY(-50%);
                    }
                }
            }
        }
        .info {
            padding: 15px;
            .sold-date {
                font-size: 12px;
                color: #505050;
            }
            .price {
                flex: 1;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 6px 0;
                div.show-price{
                    & > P {
                        font: 24px var(--font-bold);
                        color: #191919;
                        margin-right: 15px;
                    }
                    & > span {
                        font: 16px var(--font-bold);
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        &.down {
                            color: #fb4444;
                            .iconfont {
                                display: inline-block;
                                font-size: 12px;
                                transform: scaleX(0.8);
                            }
                        }
                        &.up {
                            color: #29cb97;
                            .iconfont {
                                font-size: 12px;
                                transform: scaleX(0.8) rotate(180deg);
                                display: inline-block;
                            }
                        }
                    }
                }
            }
            .address {
                font: 14px var(--font-medium);
                color: #505050;
                margin-bottom: 16px;
            }
            .mls-info {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .desc {
                    flex-shrink: 0;
                    margin-right: 20px;
                    flex: 1;
                    font-style: italic;
                    font-size: 12px;
                    color: #505050;
                }
                img {
                    max-width: 50px;
                    max-height: 24px;
                    object-fit: cover;
                }
            }
        }
    }
}
</style>
